var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"adverseRecordFrame"}},[_c(_vm.tabAction,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }